import { Component, OnInit } from "@angular/core";
import { LoginService } from "../../services/login.service";
import { Router } from "@angular/router";
import { ToastService } from "../../services/toast.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
    selector: "app-forgotten-password",
    templateUrl: "./forgotten-password.component.html",
    styleUrls: ["./forgotten-password.component.scss"],
    standalone: false
})
export class ForgottenPasswordComponent implements OnInit {
    private lastToast: ToastService.Toast | undefined;

    forgottenPasswordForm: FormGroup = new FormGroup({
        username: new FormControl("", [Validators.required]),
    });

    constructor(
        private readonly userService: LoginService,
        private readonly router: Router,
        private readonly toastService: ToastService
    ) {}

    ngOnInit(): void {}

    public async passwordReset() {
        if (!this.forgottenPasswordForm.valid) {
            return;
        }

        if (this.lastToast) {
            this.toastService.remove(this.lastToast);
            this.lastToast = undefined;
        }

        await this.userService
            .passwordReset(this.usernameControl.value)
            .then((e) => {
                if (e && e.success) {
                    this.lastToast = this.toastService.add(
                        "Forgotten password",
                        "Your password has been resetted. New password has been sent to your e-mail",
                        "success"
                    );
                    this.router.navigate(["/login"]);
                } else {
                    this.lastToast = this.toastService.add(
                        "Forgotten password failed",
                        "Could not log you in",
                        "warning"
                    );
                }
            });
    }

    public goBack() {
        this.router.navigate(["/login"]);
    }

    public get usernameControl(): FormControl {
        return this.forgottenPasswordForm.get("username") as FormControl;
    }
}
